/**
 * @link      https://karmabunny.com.au
 * @copyright Copyright (c) 2020 Karmabunny
 */


export type ConstraintType =
    | 'no-areas'
    | 'no-rates'
    | 'stop-sell'
    | 'max-occupancy'
    | 'min-occupancy'
    | 'max-nights'
    | 'min-nights'
    | 'closed-arrival'
    | 'closed-departure'
    | 'dwelling-type'
    | 'dwelling-length'
    | 'dwelling-slide'
    | 'towing-type'
    | 'min-price'
    | 'max-price'
;


export interface ConstraintItem {
    type: ConstraintType;
    require: Record<string, any>;
}


export type Constraint = {
    [key in ConstraintType]?: ConstraintItem;
}

type BecauseThings = 'min-nights' | 'min-occupancy' | 'min-price' | 'max-nights' | 'max-occupancy' | 'max-price';

export function isBecause(constraint: Constraint, type: BecauseThings): number;
export function isBecause(constraint: Constraint, type: ConstraintType): boolean | number {
    const item = constraint[type];
    if (!item) return false;

    switch (type) {
        case 'min-nights':
        case 'min-occupancy':
        case 'min-price': {
            const require = Object.values(item.require);
            return Math.min(...require);
        }
        case 'max-nights':
        case 'max-occupancy':
        case 'max-price': {
            const require = Object.values(item.require);
            return Math.max(...require);
        }
    }

    return true;
}


export function getConstraintMessage(constraint: Constraint): string {
    let type: ConstraintItem | undefined;

    if (type = constraint['min-nights']) {
        const require = Object.values(type.require);
        const value = Math.min(...require);
        return `Please book a minimum ${value} nights.`;
    }

    if (type = constraint['max-occupancy']) {
        const require = Object.values(type.require);
        const value = Math.max(...require);
        return `Cannot book more than ${value} guests.`;
    }

    if (type = constraint['min-occupancy']) {
        const require = Object.values(type.require);
        const value = Math.min(...require);
        return `Please book for at least ${value} guests.`;
    }

    return 'Please choose a different date range.';
}
